import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCoreSiteId, selectManagerSiteId } from '../../settings/reducer';
import { selectMultiSiteSelection } from '../../site-selection/reducer';
import {
  FETCH_CORE_COUNTS,
  fetchCoreCounts,
  fetchCorePayAsYouGoCounts,
  fetchInstaClubCounts,
  FETCH_CORE_PAY_AS_YOU_GO_COUNTS,
  FETCH_PRODUCT_PLAN_COUNTS,
} from '../../wash-counts/actions';
import { selectPayAsYouGoCounts, selectUniqueWashes } from '../../wash-counts/reducer';
import { selectTotalClubsGained } from '../reducer';
import InstaClubKpi from './InstaClubKpi';
import moment from 'moment';
import { getApiStatus } from '../../../core/utils';
import Big from 'big.js';

interface Props {
  fromDate: any;
  untilDate: any;
  timeZone: string;
}

const InstaClubDataGetter = (props: Props) => {
  const dispatch = useDispatch();
  const [opportunityTotal, setOpportunityTotal] = useState('0');
  const plansCount = useSelector(selectTotalClubsGained),
    multiSiteSelection = useSelector(selectMultiSiteSelection),
    managerSiteId = useSelector(selectManagerSiteId),
    unqiueWashCounts = useSelector(selectUniqueWashes),
    payAsYouGoCounts = useSelector(selectPayAsYouGoCounts),
    coreSiteId = useSelector(selectCoreSiteId);
  const instaClubLoading = useSelector((state) => getApiStatus(state, FETCH_PRODUCT_PLAN_COUNTS));
  const payAsYouGoCountsLoading = useSelector((state) =>
    getApiStatus(state, FETCH_CORE_PAY_AS_YOU_GO_COUNTS)
  );
  const fetchCoreCountsLoading = useSelector((state) => getApiStatus(state, FETCH_CORE_COUNTS));

  const handleWindowSales = () => {
    const newTimeZone = sessionStorage.getItem('timeZone') ?? props.timeZone;
    if (coreSiteId) {
      dispatch(
        fetchInstaClubCounts(
          moment.tz(props.fromDate, newTimeZone).toISOString(),
          moment.tz(props.untilDate, newTimeZone).toISOString(),
          null,
          coreSiteId
        )
      );
      dispatch(
        fetchCoreCounts(
          moment.tz(props.fromDate, newTimeZone).toISOString(),
          moment.tz(props.untilDate, newTimeZone).toISOString(),
          null,
          coreSiteId
        )
      );
      dispatch(
        fetchCorePayAsYouGoCounts(
          moment.tz(props.fromDate, newTimeZone).toISOString(),
          moment.tz(props.untilDate, newTimeZone).toISOString(),
          null,
          coreSiteId
        )
      );
    }
  };

  const calculateOpportunityTotal = () => {
    if (instaClubLoading || payAsYouGoCountsLoading || fetchCoreCountsLoading) {
      return;
    }
    const payAsYouGoCountsTotal = payAsYouGoCounts.reduce(
      (acc: any, curr: any) => acc + curr.count,
      0
    );
    setOpportunityTotal(
      Big(unqiueWashCounts).plus(plansCount).minus(payAsYouGoCountsTotal).toString()
    );
  };

  useEffect(handleWindowSales, [
    managerSiteId,
    coreSiteId,
    props.fromDate,
    props.untilDate,
    multiSiteSelection,
  ]);
  useEffect(calculateOpportunityTotal, [
    instaClubLoading,
    payAsYouGoCountsLoading,
    fetchCoreCountsLoading,
  ]);

  return (
    <InstaClubKpi
      plansCount={plansCount}
      popSingleWash={unqiueWashCounts}
      opportunityTotal={opportunityTotal}
      instaClubLoading={instaClubLoading}
      fetchCoreCountsLoading={fetchCoreCountsLoading}
      payAsYouGoCountsLoading={payAsYouGoCountsLoading}
      fromDate={props.fromDate}
      untilDate={props.untilDate}
    />
  );
};

export default InstaClubDataGetter;
